import { Spinner } from '@frontend/legacy-components';

export const HintLoadingSpinner = () => {
  return <Spinner size="sm" />;
};
